import React, { useState, useEffect } from "react";
import StarRating from "react-star-ratings";
import { GET, DELETE } from "lib/api";
import config from "lib/config";
import {
  API_RATING_GETCOMMENTS,
  API_RATING_DELETE,
} from "lib/endpoints/rating";
import withLanguageContext from "lib/hocs/withLanguageContext";
import ProfileAvatar from "Components/Fragment/ProfileAvatar";
import {
  StyledRatingComment,
  StyledRatingName,
  StyledUserAvatar,
} from "./style";

const RatingComments = (props) => {
  const { type, objectId, languageContext } = props;

  const [comments, setComments] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);

  const fetchData = async () => {
    if (!comments.length > 0 && type && objectId) {
      let fetchedComments = await GET(
        `${API_RATING_GETCOMMENTS}?${new URLSearchParams({
          type,
          objectId,
        })}`,
      );

      setComments(fetchedComments);
    }
  };

  const isSysAdmin = async () => {
    let admin = await GET("v1/users/issysadmin");
    setIsAdmin(admin);
  };

  const deleteRating = async (rating) => {
    if (confirm(languageContext("confirmDeleteRating"))) {
      await DELETE(
        `${API_RATING_DELETE}?${new URLSearchParams({
          personalId: rating.personalId,
          type: rating.type,
          objectId: rating.objectId,
        })}`,
      );

      let remainingComments = comments.filter(
        (c) => c.ratingId !== rating.ratingId,
      );
      setComments(remainingComments);
    }
  };

  useEffect(() => {
    if (config.personalId) {
      isSysAdmin();
    }

    fetchData();
  }, [type, objectId]);

  let cmts = comments.map((comment) => {
    const allowDelete = isAdmin || comment.personalId === config.personalId;

    return (
      <StyledRatingComment className="flex" key={comment.ratingId}>
        {config.personalId && (
          <StyledUserAvatar>
            <ProfileAvatar
              personalId={comment.personalId}
              title={`${comment.firstName} ${comment.lastName}`}
              size="small"
            />
          </StyledUserAvatar>
        )}
        <div>
          <div className="flex column" style={{ maxWidth: "1040px" }}>
            <StyledRatingName>
              {comment.firstName + " " + comment.lastName}
            </StyledRatingName>
            <div>
              <StarRating
                rating={comment.rating}
                starRatedColor="#f9db36"
                numberOfStars={5}
                name="rating"
                isSelectable={false}
                starDimension="14px"
                starSpacing="2px"
              />
            </div>
            <div>{comment.comment}</div>
          </div>
        </div>
        {allowDelete && (
          <div>
            <span
              className="pointer"
              style={{ position: "relative", top: "-10px" }}
              role="button"
              title={languageContext("delete")}
              onClick={() => deleteRating(comment)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  deleteRating(comment);
                }
              }}
            >
              <i
                className="iconbutton-icon icon-trash"
                aria-hidden="true"
                tabIndex="0"
              />
            </span>
          </div>
        )}
      </StyledRatingComment>
    );
  });

  return (
    <div>
      {comments.length > 0 && <h3>{languageContext("reviews")}</h3>}
      {cmts}
    </div>
  );
};

export default withLanguageContext(RatingComments, "Rating");
